import { render, staticRenderFns } from "./terms-and-conditions.vue?vue&type=template&id=013b3028&scoped=true"
import script from "./terms-and-conditions.vue?vue&type=script&lang=js"
export * from "./terms-and-conditions.vue?vue&type=script&lang=js"
import style0 from "./terms-and-conditions.vue?vue&type=style&index=0&id=013b3028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013b3028",
  null
  
)

export default component.exports